import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { ChuteSchedulerLegacyPage } from '@/pages/chute-scheduler-legacy';

import { ChuteSchedulerPage } from './index';

export const ChuteSchedulerRoute = () => {
  const redesign = useFeatureFlag('chute_scheduler_redesign');
  return redesign ? <ChuteSchedulerPage /> : <ChuteSchedulerLegacyPage />;
};
